import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import { TeamFrame } from '../components/TeamFrame';
import { TeamExtendedProfile } from 'src/replicant/team/team.schema';

import { AssetGroup } from '@play-co/timestep-core';

const ui = uiConfig.buruburu.care.confirmation;

export default class PopupTeamLeave extends PopupBasic {
  private close: (result: boolean) => void;
  private team: TeamFrame;

  constructor(opts: { superview: View; close: (success: boolean) => void }) {
    super({
      superview: opts.superview,
      close: () => {
        opts.close(false);
      },
      ...ui.popup,
      width: 600,
      height: 515,
      darkerBg: true,
      tracking: {
        feature: Feature.MATCH2.TEAM._,
        $subFeature: Feature.MATCH2.TEAM.LEAVE_POPUP._,
      },
    });

    this.close = opts.close;
    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      y: 80,
      height: 100,
      size: 22,
      color: '#BF8147',
    });

    this.team = new TeamFrame({
      superview: this.box,
      x: (this.box.style.width - 479) * 0.5,
      y: 200,
      width: 479,
      height: 157,
    });

    this.createButtons(this.box);
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  /**
   * Create buttons
   */
  private createButtons(superview: View) {
    const buttonsLayout = new FlexBoxView({
      superview,
      x: (superview.style.width - 550) * 0.5,
      y: 400,
      width: 550,
      height: 90,
      flex: {
        flexDirection: 'row',
        justifyContent: 'space-around',
      },
    });

    new ButtonScaleViewWithText({
      ...ui.backButton,
      superview: buttonsLayout,
      localeText: () => i18n('match2.team.leave_popup.no'),
      onClick: async () => {
        sounds.sfx.play('cancel');
        this.close(false);
      },
      tracking: {
        feature: Feature.MATCH2.TEAM._,
        $subFeature: Feature.MATCH2.TEAM.LEAVE_POPUP.LEAVE_POPUP_NO,
      },
    });

    new ButtonScaleViewWithText({
      ...ui.okButton,
      superview: buttonsLayout,
      localeText: () => i18n('match2.team.leave_popup.yes'),
      onClick: async () => {
        sounds.sfx.play('ok');
        this.close(true);
      },
      tracking: {
        feature: Feature.MATCH2.TEAM._,
        $subFeature: Feature.MATCH2.TEAM.LEAVE_POPUP.LEAVE_POPUP_YES,
      },
    });
  }

  /**
   * Init view
   */
  public init(team: TeamExtendedProfile): void {
    super.init({
      title: i18n('match2.team.leave_popup.title'),
      message: i18n('match2.team.leave_popup.message'),
    });

    this.team.setup(team, i18n('match2.team.leave_popup.currentTeam'));
  }
}
